module.exports = __webpack_public_path__ + "img/5.fd131de1.png";